query AnalyticsSalesByDate(
  $filter: AnalyticsSalesFilterInput!
  $calendarInterval: CalendarInterval
) {
  analyticsSales(filter: $filter) {
    salesByDate(calendarInterval: $calendarInterval) {
      calendarInterval
      items {
        label
        displayCurrency
        data {
          x
          y
        }
      }
    }
  }
}
